<template>
    <div>
        <PieChart v-if="isShowChart" ref="PieChart"></PieChart>
    </div>
</template>

<script>
import VueCharts from 'vue-chartjs'

export default {
    name: 'OverallChartRating',
    components: { PieChart: VueCharts.Pie },
    props: {
        dataSets: {
            type: Array,
            default () {
                return []
            }
        },
        labels: {
            type: Array,
            default () {
                return []
            }
        },
        colorReaction: Boolean
    },
    data () {
        let labels = []
        for (let i = 1; i < 6; i++) {
            labels.push(i + ' star(s)')
        }
        return {
            isShowChart: true
        }
    },
    watch: {
        dataSets () {
            this.renderChart()
        }
    },
    mounted () {
        this.renderChart()
    },
    methods: {
        renderChart () {
            if (this.$refs.PieChart) {
                this.$refs.PieChart.renderChart({
                    labels: this.labels,
                    datasets: this.getDatasets()
                }, {
                    responsive: false,
                    maintainAspectRatio: false,
                    legend: {
                        position: 'right',
                        align: 'center',
                        labels: {
                            generateLabels: function (chart) {
                                return chart.data.labels.map((label, i) => {
                                    let meta = chart.getDatasetMeta(0)
                                    let ds = chart.data.datasets[0]
                                    return {
                                        text: label + ':  ' + ds.data[i],
                                        fillStyle: ds.backgroundColor[i],
                                        strokeStyle: ds.backgroundColor[i],
                                        lineWidth: 0,
                                        hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                                        index: i
                                    }
                                })
                            }
                        }
                    },
                    plugins: {
                        datalabels: {
                            formatter: (value, ctx) => {
                                let sum = 0
                                let dataArr = ctx.chart.data.datasets[0].data
                                dataArr.map(data => {
                                    sum += data
                                })
                                let percentage = value > 0 ? (value * 100 / sum).toFixed(2) + '%' : ''
                                return percentage
                            },
                            color: '#fff'
                        }
                    }
                })
            }
        },
        getDatasets () {
            return [
                {
                    labels: 'dataset 1',
                    data: this.dataSets,
                    backgroundColor: this.colorReaction ? this.$const.reactionColors : this.$const.rateColors1to5
                }
            ]
        }
    }
}
</script>

<style scoped>

</style>
